import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip, IconButton, Paper } from '@mui/material';
import { Contrast, Type, Volume2, Globe } from 'lucide-react';

export const AccessibilityToolbar: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [highContrast, setHighContrast] = useState(false);
  const [dyslexicFont, setDyslexicFont] = useState(false);

  const toggleHighContrast = () => {
    const next = !highContrast;
    setHighContrast(next);
    document.body.classList.toggle('high-contrast', next);
  };

  const toggleDyslexicFont = () => {
    const next = !dyslexicFont;
    setDyslexicFont(next);
    document.body.classList.toggle('font-opendyslexic', next);
  };

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Paper 
      elevation={4} 
      className="fixed bottom-4 right-4 z-50 p-2 flex items-center gap-2 bg-white rounded-full border border-slate-200 shadow-xl"
      role="region"
      aria-label="Accessibility Toolbar"
    >
      <Tooltip title={t('high_contrast')}>
        <IconButton 
          color={highContrast ? "secondary" : "default"} 
          onClick={toggleHighContrast}
          aria-label={t('high_contrast')}
        >
          <Contrast className="w-5 h-5" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t('font_dyslexic')}>
        <IconButton 
          color={dyslexicFont ? "secondary" : "default"} 
          onClick={toggleDyslexicFont}
          aria-label={t('font_dyslexic')}
        >
          <Type className="w-5 h-5" />
        </IconButton>
      </Tooltip>

      <div className="h-6 w-px bg-slate-300 mx-1" />

      {/* Language Switcher */}
      <div className="flex items-center gap-1">
        <Globe className="w-4 h-4 text-slate-500 ml-1" />
        <Button size="small" onClick={() => changeLanguage('en')} variant={i18n.language === 'en' ? 'contained' : 'text'}>
          EN
        </Button>
        <Button size="small" onClick={() => changeLanguage('hi')} variant={i18n.language === 'hi' ? 'contained' : 'text'}>
          HI
        </Button>
        <Button size="small" onClick={() => changeLanguage('mr')} variant={i18n.language === 'mr' ? 'contained' : 'text'}>
          MR
        </Button>
      </div>
    </Paper>
  );
};
